module.exports = __webpack_public_path__ + "img/icon-mc.bb18bc9c.png";